<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'

import Resizable from '@src/mixins/resizable.js'
import HowToUseStep from '@components/get-your-pass/how-to-use-step.vue'

export default {
  mixins: [
    Resizable
  ],
  props: {
    steps: {
      type: Array,
      required: true
    }
  },
  components: {
    HowToUseStep,
    Swiper,
    SwiperSlide
  },
  data() {
    return {
      howToUseSliderOptions: {
        allowTouchMove: true,
        spaceBetween: 20,
        pagination: {
          el: '.pagination',
          clickable: true,
          bulletClass: 'bullet',
          bulletActiveClass: 'bullet-active'
        },
        breakpoints: {
          320: {
            slidesPerView: 1.2,
            slidesPerGroup: 1.2,
          },
        }
      },
    }
  },
}
</script>

<template>
  <div class="wrapper">
    <div v-if="desktopScreen" class="how-to-use-steps">
      <HowToUseStep
          v-for="(item, index) in steps"
          :key="index"
          :step="item"
          :ordering-num="index + 1"
      />
    </div>
    <div v-else class="how-to-use-slider">
      <Swiper :options="howToUseSliderOptions">
        <SwiperSlide v-for="(item, index) in steps" :key="index" class="how-to-use-slide">
          <HowToUseStep
            :step="item"
            :ordering-num="index + 1"
          />
        </SwiperSlide>
        <div slot="pagination" class="pagination"></div>
      </Swiper>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.how-to-use-steps {
  display: grid;
  margin-top: 30px;
  column-gap: 20px;
  grid-template-columns: repeat(4, 1fr);
}

@media only screen and (max-width: $container-width-xs) {
  .how-to-use-steps {
    grid-template-columns: repeat(1, 1fr);
  }

  .how-to-use-slider {
    margin-top: 15px;
  }

  .pagination {
    margin-top: 15px;
  }
}
</style>
